import React, { createContext, useState } from 'react'

export interface OrganizationContextType {
  isUnsaved: boolean
  setUnsaved: (status: boolean) => void
  warningPopup: boolean
  setWarningPopup: (status: boolean) => void
}

const defaultValues: OrganizationContextType = {
  isUnsaved: false,
  setUnsaved: () => {},
  warningPopup: false,
  setWarningPopup: () => {},
}

export const OrganizationContext =
  createContext<OrganizationContextType>(defaultValues)

const OrganizationProvider = ({ children }: { children: React.ReactNode }) => {
  const [isUnsaved, setUnsaved] = useState<boolean>(false)
  const [warningPopup, setWarningPopup] = useState<boolean>(false)

  return (
    <OrganizationContext.Provider
      value={{
        isUnsaved,
        setUnsaved,
        warningPopup,
        setWarningPopup,
      }}
    >
      {children}
    </OrganizationContext.Provider>
  )
}

export default OrganizationProvider
